import { Box, InputAdornment, TextField, useTheme } from "@mui/material";
import { QuantityPrice } from 'common-models';

import { ChangeEvent, FC, useEffect, useState } from 'react';


type QuantityPriceEditorProps = {
    originalQuantityPrice: QuantityPrice,
    onQuantityChangedCallback: (changedPrice: QuantityPrice, newQuantity: number) => void,
    onPriceChangedCallback: (changedPrice: QuantityPrice, newPrice: number) => void,
    isPlaceholder?: boolean
}

const QuantityPriceEditor: FC<QuantityPriceEditorProps> = ({ originalQuantityPrice, onQuantityChangedCallback, onPriceChangedCallback, isPlaceholder = false }) => {

    const [quantityPrice] = useState({ ...originalQuantityPrice });

    useEffect(() => {
        console.info(`Editing quantity price ${quantityPrice.id}`);
    }, [quantityPrice]);

    const onChangeQuantity = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const quantity = Number.parseInt((event.target as HTMLInputElement).value);
        onQuantityChangedCallback(quantityPrice, quantity);
    }

    const onChangeQuantityPrice = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const priceInSekExclVat = Number.parseInt((event.target as HTMLInputElement).value);
        onPriceChangedCallback(quantityPrice, priceInSekExclVat);
    }

    const theme = useTheme();

    return (
        <Box sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            p: 1
        }}>
            <TextField
                defaultValue={quantityPrice.quantity || ''}
                variant="outlined"
                type="number"
                label="Quantity"
                placeholder={isPlaceholder ? "Enter quantity..." : ""}
                onChange={onChangeQuantity}
                size="small"
                sx={{
                    minWidth: 120,
                    flex: '0 1 auto',
                    ...(isPlaceholder && {
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: theme.palette.primary.main,
                                borderStyle: 'dashed',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: theme.palette.primary.main,
                        }
                    })
                }}
                inputProps={{
                    min: 0,
                    step: 1
                }}
            />
            <TextField
                defaultValue={quantityPrice.priceInSekExclVat || ''}
                variant="outlined"
                type="number"
                label="Price"
                placeholder={isPlaceholder ? "Enter price..." : ""}
                onChange={onChangeQuantityPrice}
                size="small"
                sx={{
                    minWidth: 150,
                    flex: '1 1 auto',
                    ...(isPlaceholder && {
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: theme.palette.primary.main,
                                borderStyle: 'dashed',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: theme.palette.primary.main,
                        }
                    })
                }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">SEK</InputAdornment>,
                }}
                inputProps={{
                    min: 0,
                    step: 0.01
                }}
                helperText={isPlaceholder ? "Enter values to add this price tier" : "Price excluding VAT"}
            />
        </Box>
    )
}

export default QuantityPriceEditor;
